export default __webpack_public_path__ + "static/pricing-pattern-1d677e17700cd0657d14138d141e692d.png";